export default __webpack_public_path__ + "static/media/business-anamoly.6313c85b.svg";